
import { Board } from "./types";

export const ensureValidBoardName = (title: string): string => {
  // Ensure the title is not empty and trim it
  const trimmedTitle = title?.trim() || '';
  return trimmedTitle || 'Untitled Board';
};

export const getBoardDisplayName = (
  board: Partial<Board>,
  getBoardById?: (id: string) => Board | undefined,
  allBoards?: Board[]
): string => {
  // If we have a complete board with a title, use it
  if (board.title) {
    return board.title;
  }

  // If we have a board ID and a lookup function, try to get the title
  if (board.id && getBoardById) {
    const foundBoard = getBoardById(board.id);
    if (foundBoard?.title) {
      return foundBoard.title;
    }
  }

  // If we have a board ID and a list of all boards, find it there
  if (board.id && allBoards?.length) {
    const foundBoard = allBoards.find(b => b.id === board.id);
    if (foundBoard?.title) {
      return foundBoard.title;
    }
  }

  // Fallback
  return 'Unknown Board';
};
